import SearchAmotPage from "components/searchAmot/SearchAmotPage"
import { GetStaticProps } from "next"
import { NextSeo } from "next-seo"
import { useRouter } from "next/router"

const Search = () => {
  const { locale } = useRouter()
  return (
    <>
      <NextSeo
        title={locale === "he" ? "חיפוש" : "Search"}
        openGraph={{
          title: locale === "he" ? "חיפוש" : "Search",
        }}
      />
      <SearchAmotPage />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      messages: (await import(`../../messages/${locale}.json`)).default,
    },
    revalidate: 60,
  }
}

export default Search
